<template>
  <div class="py-32 border-solid border-b-2 border-border-tertiary">
    <div class="flex flex-row gap-16 items-center">
      <div
        class="p-16 rounded-full w-fit"
        :class="active ? 'bg-surface-secondary' : 'bg-surface-disabled'"
      >
        <nuxt-icon
          :name="icon"
          class="text-[2.4rem]"
          :class="active ? 'text-text-primary' : 'text-text-disabled'"
          aria-hidden="true"
        ></nuxt-icon>
      </div>
      <h3
        class="heading-xs"
        :class="active ? 'text-text-primary' : 'text-text-disabled'"
      >
        {{ heading }}
      </h3>
    </div>
    <slot v-if="active"></slot>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  icon: string;
  heading: string;
  active: boolean;
}
defineProps<Props>();
</script>

<style></style>
